export enum JobSort {
  PRIORITY = 'priority',
  CREATED = 'created',
  USER = 'user',
}
